module.exports = __webpack_public_path__ + "static/media/about-pgm.81bf50e5.webp";